import React from "react";
import { useSelector } from "react-redux";
import SummaryCard from "../../../UI-component/summary/SummaryCard";
import NextBtnForm from "../../../UI-component/NexBtnForm";
import FormBoxField from "../../../UI-component/ui-el/FormBoxField";
import SuccessfullPopup from "../../../UI-component/SuccessfullPopup";
import Loader from "../../../UI-component/Loader";
import { useAccess } from "./access";
import { getTenantCode } from "../../../util";

function Summary(props) {
    const ctx = useSelector(state => state.stepSlice.data);

    const {
        data,
        values,
        loading,
        error,
        isValidStep,
        getPrefs,
        update,
        updateField,
        updatePrefs,
        save,
        savePrefs
    } = useAccess(props.save, null, props.send);

    const onNext = async () => {
        save(true);
    };

    const tenantCode = getTenantCode();
    const shouldShowAddressField = data?.modalita === "Invio tramite raccomandata";
    const shouldShowPECField = data?.modalita === "Invio tramite PEC";
    const isUfficioTecnico =
        tenantCode === "B214" && data?.tipologia === (values?.types?.[2]?.value || "");
    const shouldShowMarca =
        tenantCode === "L337"
            ? (values?.extra_declarations
                ? data?.chiede_extra === values?.extra_declarations?.[3]?.value
                : false)
            : isUfficioTecnico && values?.releaseModes
                ? data?.mediante === values?.releaseModes?.[2]?.value
                : false;

    const applicant = data?.richiedente?.[0];
    const delegate = data?.delegato?.[0];

    const renderImmobileSummary = () => {
        if (!isUfficioTecnico) return null;

        const immobile = data?.immobile || {};

        return (
            <SummaryCard type="Immobile">
                <FormBoxField
                    title="Indirizzo immobile"
                    value={immobile?.indirizzo || "Non compilato"}
                />
                <FormBoxField
                    title="In qualità di"
                    value={immobile?.tipologia || "Non compilato"}
                />
            </SummaryCard>
        );
    };

    const renderDocumentsSummary = () => {
        if (!isUfficioTecnico) return null;

        const docs = data?.documenti || {};
        const immobileType = data?.immobile?.tipologia || "";
        const isTecnico = immobileType.includes("Tecnico");
        const isCTU = immobileType.includes("CTU");
        const shouldShowDelegationDoc = isTecnico;
        const shouldShowCTUDoc = isCTU;
        const shouldShowContractDoc = immobileType.includes("Futuro acquirente");

        return (
            <SummaryCard type="Allegati">
                <FormBoxField
                    title="Visura catastale dell'immobile"
                    value={docs?.visura_catastale_immobile || "Non compilato"}
                />
                <FormBoxField
                    title="Pagamento diritti di segreteria per rimborso costi di ricerca"
                    value={docs?.pagamento_diritti_segreteria || "Non compilato"}
                />
                {shouldShowDelegationDoc && (
                    <FormBoxField
                        title="Delega / lettera di incarico"
                        value={docs?.delega_incarico || "Non compilato"}
                    />
                )}
                {shouldShowCTUDoc && (
                    <FormBoxField
                        title="Copia incarico del tribunale"
                        value={docs?.incarico_tribunale || "Non compilato"}
                    />
                )}
                {shouldShowContractDoc && (
                    <FormBoxField
                        title="Copia del contratto o autorizzazione del proprietario"
                        value={docs?.contratto_autorizzazione_proprietario || "Non compilato"}
                    />
                )}
            </SummaryCard>
        );
    };

    return (
        <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
                <div className="steppers-content" aria-live="polite">
                    <div className="it-page-sections-container">
                        <div
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-55%,-50%)",
                                zIndex: "10000"
                            }}
                        >
                            <Loader loading={loading} />
                        </div>

                        <SummaryCard
                            type="richiedente"
                            cardTitle={`${applicant?.anagrafica?.nome} ${applicant?.anagrafica?.cognome}`}
                            mod={true}
                            update={update}
                            id={"Richiedente"}
                            taxID={applicant?.anagrafica?.codice_fiscale}
                            service={props.info.code}
                            registryData={applicant}
                        >
                            <FormBoxField title="Tipo" value={applicant?.type?.type} />
                            <FormBoxField title="Nome" value={applicant?.anagrafica?.nome} />
                            <FormBoxField title="Cognome" value={applicant?.anagrafica?.cognome} />
                            <FormBoxField title="Codice Fiscale" value={applicant?.anagrafica?.codice_fiscale} />
                            <FormBoxField title="Data di nascita" value={applicant?.anagrafica?.data_di_nascita} />
                            <FormBoxField title="Luogo di nascita" value={applicant?.anagrafica?.luogo_di_nascita} />
                            <FormBoxField title="Indirizzo residenza" value={applicant?.indirizzi?.residenza} />
                            <FormBoxField title="Comune residenza" value={applicant?.indirizzi?.domicilio} />
                            <FormBoxField title="Telefono" value={applicant?.contatti?.telefono} />
                            <FormBoxField title="Email" value={applicant?.contatti?.email} />
                            <FormBoxField title="Carta di identità" value={applicant?.documenti?.carta_di_identita} />
                            {applicant?.type?.type === "Delegato" && (
                                <FormBoxField title="Delega" value={applicant?.documenti?.delega} />
                            )}
                        </SummaryCard>

                        {data?.delegato?.length > 0 && (
                            <SummaryCard
                                type="delegato"
                                cardTitle={`${delegate?.anagrafica?.nome} ${delegate?.anagrafica?.cognome}`}
                                mod={true}
                                update={update}
                                id={"Delegato"}
                                title={"Delegante"}
                                taxID={delegate?.anagrafica?.codice_fiscale}
                                service={props.info.code}
                                registryData={delegate}
                            >
                                <FormBoxField title="Nome" value={delegate?.anagrafica?.nome} />
                                <FormBoxField title="Cognome" value={delegate?.anagrafica?.cognome} />
                                <FormBoxField title="Codice Fiscale" value={delegate?.anagrafica?.codice_fiscale} />
                                <FormBoxField title="Data di nascita" value={delegate?.anagrafica?.data_di_nascita} />
                                <FormBoxField title="Luogo di nascita" value={delegate?.anagrafica?.luogo_di_nascita} />
                                <FormBoxField title="Indirizzo residenza" value={delegate?.indirizzi?.residenza} />
                                <FormBoxField title="Comune residenza" value={delegate?.indirizzi?.domicilio} />
                                <FormBoxField title="Telefono" value={delegate?.contatti?.telefono} />
                                <FormBoxField title="Email" value={delegate?.contatti?.email} />
                                <FormBoxField title="Carta di identità" value={delegate?.documenti?.carta_di_identita} />
                            </SummaryCard>
                        )}

                        <SummaryCard
                            type="Preferenze"
                            mod={true}
                            cardTitle={`Preferenze di servizio`}
                            service="RAAT"
                            registryData={{
                                access: data
                            }}
                            choiceData={[
                                {
                                    options: values.types || [],
                                    title: ["ACCESSI", "TIPOLOGIA"],
                                    type: "Select",
                                    id: "tipologia"
                                },
                                {
                                    options: values.modes || [],
                                    title: ["ACCESSI", "MODALITA"],
                                    type: "Select",
                                    id: "modalita"
                                },
                                ...(shouldShowAddressField
                                    ? [
                                        {
                                            options: [
                                                {
                                                    id: 1,
                                                    title: "Indirizzo spedizione"
                                                }
                                            ],
                                            title: ["ACCESSI", "INDIRIZZO"],
                                            child_title: [],
                                            type: "MultiText",
                                            id: "indirizzo_spedizione"
                                        }
                                    ]
                                    : []),
                                ...(shouldShowPECField
                                    ? [
                                        {
                                            options: [
                                                {
                                                    title: "Indirizzo PEC"
                                                }
                                            ],
                                            title: ["ACCESSI", "PEC"],
                                            child_title: [],
                                            type: "MultiText",
                                            id: "indirizzo_pec"
                                        }
                                    ]
                                    : []),
                                ...(isUfficioTecnico
                                    ? [
                                        {
                                            options: values?.releaseModes || [],
                                            title: ["ACCESSI", "MEDIANTE"],
                                            type: "Select",
                                            id: "mediante"
                                        }
                                    ]
                                    : []),
                                {
                                    options: [
                                        { id: 1, title: "Documento" },
                                        { id: 2, title: "Informazione" },
                                        { id: 3, title: "Dato" }
                                    ],
                                    title: ["ACCESSI", "CHIEDE"],
                                    child_title: ["Documento", "Informazione", "Dato"],
                                    id: "chiede",
                                    type: "MultiText"
                                },
                                {
                                    options: [{ id: 1, title: "Motivo" }],
                                    title: ["ACCESSI", "MOTIVO"],
                                    child_title: [],
                                    type: "MultiText",
                                    id: "motivo"
                                },
                                ...(tenantCode === "L337"
                                    ? [
                                        {
                                            options: values?.extra_declarations || [],
                                            title: ["ACCESSI", "CHIEDE"],
                                            type: "Select",
                                            id: "chiede_extra"
                                        }
                                    ]
                                    : []),
                                ...(shouldShowMarca
                                    ? [
                                        {
                                            options: [
                                                {
                                                    id: "numero",
                                                    title: "Numero marca",
                                                    regex: "^[0-9]{14}$",
                                                    max: "14",
                                                    useId: true
                                                },
                                                {
                                                    id: "data",
                                                    title: "Data marca",
                                                    useId: true,
                                                    type: "date"
                                                }
                                            ],
                                            title: ["ACCESSI", "MARCA BOLLO"],
                                            child_title: [],
                                            type: "MultiText",
                                            id: "marca_bollo"
                                        }
                                    ]
                                    : [])
                            ]}
                            update={updatePrefs}
                        >
                            <FormBoxField
                                title="Tipologia"
                                value={data?.tipologia || "Non compilato"}
                            />
                            <FormBoxField
                                title="Modalità di ritiro"
                                value={data?.modalita || "Non compilato"}
                            />
                            {isUfficioTecnico && (
                                <FormBoxField
                                    title="Mediante"
                                    value={data?.mediante || "Non compilato"}
                                />
                            )}
                            {data?.modalita === "Invio tramite raccomandata" && (
                                <FormBoxField
                                    title="Indirizzo di spedizione"
                                    value={data?.indirizzo_spedizione || "Non compilato"}
                                />
                            )}
                            {data?.modalita === "Invio tramite PEC" && (
                                <FormBoxField
                                    title="Indirizzo PEC"
                                    value={data?.indirizzo_pec || "Non compilato"}
                                />
                            )}
                            <FormBoxField
                                title="Documento"
                                value={data?.chiede?.documento || "Non compilato"}
                            />
                            <FormBoxField
                                title="Informazione"
                                value={data?.chiede?.informazione || "Non compilato"}
                            />
                            <FormBoxField
                                title="Dato"
                                value={data?.chiede?.dato || "Non compilato"}
                            />
                            <FormBoxField
                                title="Motivo"
                                value={data?.motivo || "Non compilato"}
                            />
                            {tenantCode === "L337" && (
                                <FormBoxField
                                    title="Chiede"
                                    value={data?.chiede_extra || "Non compilato"}
                                />
                            )}
                            {shouldShowMarca && (
                                <>
                                    <FormBoxField
                                        title="Numero marca da bollo"
                                        value={data?.marca_bollo?.numero || "Non compilato"}
                                    />
                                    <FormBoxField
                                        title="Data marca da bollo"
                                        value={data?.marca_bollo?.data || "Non compilato"}
                                    />
                                </>
                            )}
                            {Array.isArray(data?.dichiaro) &&
                                data?.dichiaro.map(el => (
                                    <FormBoxField
                                        key={el}
                                        title="Dichiaro"
                                        value={el?.indexOf("-") === 1 ? el?.slice(2) : el}
                                    />
                                ))}
                        </SummaryCard>

                        {renderImmobileSummary()}
                        {renderDocumentsSummary()}

                        <NextBtnForm
                            send={onNext}
                            back={props.back}
                            saveRequest={save}
                            last={true}
                            noSave={false}
                        />
                        {props.saved && <SuccessfullPopup />}
                        {props.fail && <SuccessfullPopup isError={true} />}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Summary;
